import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const Refills1Icon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 38 39", width: sizePx, style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round" },
                React.createElement("path", { d: "M36.798 19.7c0 9.885-8.014 17.899-17.899 17.899C9.014 37.599 1 29.585 1 19.699 1 9.815 9.014 1.8 18.899 1.8c2.566 0 5.006.54 7.212 1.513" }),
                React.createElement("path", { d: "M26.2 10.538h8.903V1.385" })))));
};
export default Refills1Icon;
//# sourceMappingURL=index.js.map